import React from 'react';
import { Table, Checkbox, Tag, Icon, SupportedIconName, Button, BodyText } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { LocaleResponse } from '@cdaas/api-clients/dist/product-service-openapi';

import { selectAllSalesChannels } from '../../../store/salesChannels';
import { RootState } from '../../../store';
import { ProductsListItem as ProductsListItemType } from './ProductsList';
import PropertiesText from './PropertiesText';
import SalesChannelInfo from '../../../shared/ListUtil/SalesChannelInfo';
import LanguageList from '../../../shared/ListUtil/LanguageList';

interface ProductListItemProps {
  children?: JSX.Element | JSX.Element[];
  locales: LocaleResponse[];
  open: boolean;
  product: ProductsListItemType;
  selected: boolean;
  onProductChecked: (product: ProductsListItemType) => void;
  onClickProductRow: (product: ProductsListItemType) => void;
  onOpenProductRow: (product: ProductsListItemType) => void;
}

export default function ProductsListItem(props: ProductListItemProps) {
  const { t } = useTranslation('productsscreen');
  const allSalesChannels = useSelector((state: RootState) => selectAllSalesChannels(state));
  const { children, open, selected, locales, product, onOpenProductRow, onClickProductRow, onProductChecked } = props;
  const { brand, name, locale_ids, variants_count, sku, sales_channel_uuids, properties } = product;
  const isParent = product && product.variants_count > 1;

  const VariantTag = ({ variants_count }: { variants_count: number }) => {
    if (!variants_count || variants_count === 1) {
      return null;
    }
    return (
      <Tag className={'telia-react-table_row__variants'} backgroundColor={'blue600'}>
        {`${variants_count} ${t('productsTable.variants')}`}
      </Tag>
    );
  };

  const toggleListItem = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation();
    onOpenProductRow(product);
  };

  const ArrowIcon = () => {
    const iconName = open ? 'chevron-down' : 'chevron-right';
    return (
      <Button variant={'text'} onClick={toggleListItem}>
        <Icon name={iconName as SupportedIconName} clickableAppearance={true} size={'sm'} />
      </Button>
    );
  };

  return (
    <>
      <Table.Row className="telia-react-table_row__master">
        <Table.Cell type="checkbox">
          <Checkbox checked={selected} onChange={() => onProductChecked(product)} onClick={event => event.stopPropagation()} />
        </Table.Cell>
        <Table.Cell>{isParent && <ArrowIcon />}</Table.Cell>
        <Table.Cell className="daas-product-table__brand" onClick={() => onClickProductRow(product)}>
          <BodyText>{brand}</BodyText>
        </Table.Cell>
        <Table.Cell className="daas-product-table__name" onClick={() => onClickProductRow(product)}>
          <BodyText>
            {name}
            <PropertiesText properties={properties} />
          </BodyText>
        </Table.Cell>
        <Table.Cell>
          <VariantTag variants_count={variants_count} />
        </Table.Cell>
        <Table.Cell>
          <BodyText>{sku}</BodyText>
        </Table.Cell>
        <Table.Cell>
          <LanguageList languages={locale_ids} locales={locales} />
        </Table.Cell>
        <Table.Cell>{/*<Availability />*/}</Table.Cell>
        <Table.Cell>
          {!isParent && <SalesChannelInfo allSalesChannels={allSalesChannels} variantSalesChannelUuids={sales_channel_uuids} />}
        </Table.Cell>
      </Table.Row>
      {children}
    </>
  );
}
